import { NgModule } from '@angular/core';
import { CDCUserAccountModule } from '@spartacus/cdc/user-account';
import { CustomLoginModule } from './custom-login/custom-login.module';
import { CustomUserAccountModule } from './account/user-account.module';

@NgModule({
  declarations: [],
  imports: [CustomUserAccountModule, CDCUserAccountModule, CustomLoginModule],
})
export class UserAccountWrapperModule {}
